@if (open()) {
<div class="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm" (click)="onClose()"></div>
<div class="fixed inset-0 z-50 flex items-center justify-center p-2">
    <div class="bg-white rounded-2xl shadow-2xl w-full max-w-2xl flex flex-col overflow-hidden"
        (click)="$event.stopPropagation()">
        <div class="flex justify-between border-b">
            <h1 class="p-3 fs-16 fw-600">{{'PAYMESTR0038' | translate}}</h1>
            <button (click)="onClose()" class="p-3 fw-600">
                <i class="pi pi-times"></i>
            </button>
        </div>
        <hr>

        <div class="w-full p-3 flex flex-col gap-3">
            <div class="grid grid-cols-12 gap-3">
                <input type="text" class="input-text col-span-10 w-full" [placeholder]="'PAYMESTR0052' | translate"
                    (input)="onPhoneInput($event)" [(ngModel)]="param.P_TEL_NO" (keydown.enter)="getData()">
                <button class="btn-custom col-span-2 justify-center" (click)="getData()">{{'PAYMESTR0044' |
                    translate}}</button>
            </div>
            <div>
                <app-material-table class="h-full min-h-0" [headers]="memberHeaders()" [data]="data()"
                    [key]="'membeR_NO'" [rowTemplate]="memberRowTpl" [enablePagination]="true" [pageSize]="P_PAGEROW"
                    [totalCnt]="data().length" [width]="'w-full'">
                </app-material-table>

                <ng-template #memberRowTpl let-item>
                    <tr class="h-10 hover:bg-gray-50 text-center fs-14" (click)="onAddToCart(item)">
                        <td class="border-r border-b border-gray-200 px-2 text-left">{{ item.membeR_NM }}</td>
                        <td class="border-r border-b border-gray-200 px-2">{{ item.hP_NO |phoneFormat}}</td>
                        <td class="border-r border-b border-gray-200 px-2">{{ item.membeR_TP_NM }}</td>
                        <!-- <td class="border-r border-b border-gray-200 px-2">{{ item.avaiL_POINT | number }}</td> -->
                    </tr>
                </ng-template>
            </div>
            <!-- <div class="mt-8 flex justify-end">
                <button (click)="onClose()"
                    class="px-6 py-3 bg-gray-100 text-gray-700 font-bold rounded-lg hover:bg-gray-200 transition-colors">
                    {{ 'Close' | translate }}
                </button>
            </div> -->
        </div>
    </div>
</div>
}